var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeciplineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.0489C6.93587 11.4346 5.72876 11.1111 4.5 11.1111C3.27124 11.1111 2.06413 11.4346 1 12.0489V1.93782C2.06413 1.32344 3.27124 1 4.5 1C5.72876 1 6.93587 1.32344 8 1.93782M8 12.0489C9.06413 11.4346 10.2712 11.1111 11.5 11.1111C12.7288 11.1111 13.9359 11.4346 15 12.0489V1.93782C13.9359 1.32344 12.7288 1 11.5 1C10.2712 1 9.06413 1.32344 8 1.93782M8 12.0489V1.93782",
    stroke: "#363636",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeciplineIcon);
export default __webpack_public_path__ + "static/media/decipline-icon.f055afedc805bd3ac1b24e6937196bb2.svg";
export { ForwardRef as ReactComponent };